import { render, staticRenderFns } from "./PagosPendientes.vue?vue&type=template&id=45b6ea48&scoped=true&"
import script from "./PagosPendientes.vue?vue&type=script&lang=js&"
export * from "./PagosPendientes.vue?vue&type=script&lang=js&"
import style0 from "./PagosPendientes.vue?vue&type=style&index=0&id=45b6ea48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b6ea48",
  null
  
)

export default component.exports